import styled from "styled-components";

const WeightSelector = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex: 1;
  
  &.large-weight {
    max-width: 188px;
  }

  .weight-selector__weight {
    padding: .5rem 16px .5rem 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: ${({theme}) => theme.colors.white};
    color: ${({theme}) => theme.colors.gray3};
    outline: none;
    line-height: 1;
    transition: var(--button-transition);

    &.is-active {
      color: ${({theme}) => theme.colors.brandDark};
    }

    &:hover,
    &:focus {
      .weight-selector__radio {
        border-color: ${({theme}) => theme.colors.brandDark};
      }
      color: ${({theme}) => theme.colors.brandDark};
    }
  }

  .weight-selector__copy {
    color: ${({theme}) => theme.colors.brandDark};
  }

  .weight-selector__radio {
    margin-right: 6px;
    position: relative;
    height: 14px;
    width: 14px;
    background-color: transparent;
    border: 2px solid ${({theme}) => theme.colors.gray3};
    border-radius: 50%;
    flex-shrink: 0;
    transition: var(--button-transition);

    &.is-active {
      background-color: ${({theme, outStock}) => outStock ? theme.colors.gray2 : theme.colors.brandDark};
      border-color: ${({theme, outStock}) => outStock ? theme.colors.gray3 : theme.colors.brandDark};
    }
  }  

  .weight-selector__radio__no-quantity {
    background-color: ${({theme}) => theme.colors.gray2};
    border-color: ${({theme}) => theme.colors.gray2};
  }

  .weight-selector__weight__no-quantity {
    .weight-selector__radio {
      background-color: ${({theme}) => theme.colors.gray2};
      border-color: ${({theme}) => theme.colors.gray3};
    }
    &:hover,
    &:focus {
      .weight-selector__radio {
        border-color: ${({theme}) => theme.colors.gray2};
      }
    }
  }

`;

export default WeightSelector;